<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" title="Change file" @hidden="clearModalData">
    <!-- upload picker modal -->
    <MediaUploadPicker v-if="show" :isModal=true @create-file-clicked="replaceFileProxy('image')"
      @create-video-clicked="replaceFileProxy('video')" @create-url-clicked="this.createURLProxy" />
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-button variant="light" class="float-right mx-2" @click="modalCancel">Cancel</b-button>
    </div>
  </b-modal>
</template>

<script>
import MediaUploadPicker from '@/components/MediaUploadPicker.vue';
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  mixins: [mediaMixin],
  components: {
    MediaUploadPicker,
  },
  data() {
    return {
      show: false,
      file: null,
      dir: null,
    };
  },
  created() {
    this.$root.$on('modal-show-change-file', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-change-file', this.showModal);
  },
  methods: {
    showModal({
      file,
      dir,
    }) {
      this.show = true;
      this.file = file;
      this.dir = dir;
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.show = false;
      this.file = null;
      this.dir = null;
    },
    modalCancel() {
      this.hideModal();
    },
    replaceFileProxy(type) {
      // save current dir reference for background upload as user might navigate away
      const currentDirRef = this.dir;
      const fileToReplace = this.file;
      const modal = type === 'image' ? 'modal-show-upload-files' : 'modal-show-upload-videos';
      this.$root.$emit(modal, {
        title: 'Replace',
        body: 'Select file to upload',
        cbConfirm: (file) => {
          const filesPromises = [];
          const filePromise = this.createFile({ name: file.name.split('.').slice(0, -1).join('.') }, currentDirRef, file, type, fileToReplace);
          filesPromises.push(filePromise);
          this.$root.$emit('notification-add', {
            content: `File ${file.name} uploading...`,
            variant: 'info',
            ttl: Infinity,
            promise: filePromise,
          });
          // handle the promise
          filePromise.then((fileInfo) => {
            if (fileToReplace) {
              const fileToUpdateIndex = currentDirRef.files.findIndex(f => f.id === fileToReplace.id);
              // currentDirRef.files.replace;
              currentDirRef.files.splice(fileToUpdateIndex, 1, fileInfo);
              return;
            }
            currentDirRef.files.push(fileInfo);
            if (currentDirRef.id === this.currentDirectory.id) { currentDirRef.files.push(fileInfo); }
          }).catch(() => { });
        },
        confirmText: 'Upload',
        cancelText: 'Cancel',
        isMultiple: false,
      });
      this.hideModal();
    },
  },
  computed: {
    selectedFiles() {
      return [...this.devicesArray, ...this.devicesFilterArray];
    },
  },
};
</script>
